import { isNull } from "@tsparticles/engine";
import { PolygonMaskDrawStroke } from "./PolygonMaskDrawStroke.js";
export class PolygonMaskDraw {
    constructor(engine) {
        this.enable = false;
        this.stroke = new PolygonMaskDrawStroke(engine);
    }
    load(data) {
        if (isNull(data)) {
            return;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        const stroke = data.stroke;
        this.stroke.load(stroke);
    }
}
